import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import { CUSTOM_MODEL_QUERY_KEYS } from './query-keys';

export interface TrainingRound {
  id: number;
  round_number: number;
  training_status: number;
  started_at: string | null;
  finished_at: string | null;
  asr_version: string | null;
  wer: number | null;
  log_name: string | null;
  data_count: number | null;
}

export interface TrainingRoundsResponse {
  result: TrainingRound[];
  total_results: number;
}

export const useGetTrainingRounds = (
  modelId: number | undefined,
  enabled = true
) => {
  return useQuery<TrainingRoundsResponse, AxiosError<BaseError>>(
    CUSTOM_MODEL_QUERY_KEYS.rounds(modelId!),
    async () => {
      const url = GET_URL(String(modelId)).customModelRounds;
      const { data } = await Axios.get<TrainingRoundsResponse>(url);
      return data;
    },
    {
      enabled: Boolean(modelId) && enabled,
      staleTime: 15000,
      // Only poll while a round is in a non-terminal state: PROVISIONING (2)
      // or RUNNING (3). Once all rounds are Success/Failed/Not-running the
      // history is static — polling every 20s just re-rendered the grid.
      refetchInterval: data => {
        const hasActive = data?.result?.some(
          r => r.training_status === 2 || r.training_status === 3
        );
        return hasActive ? 20000 : false;
      },
      refetchIntervalInBackground: true,
      // See note on use-get-custom-models.tsx.
      refetchOnWindowFocus: false,
      useErrorBoundary: false
    }
  );
};
